import React from 'react';
import { useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import './AppLayout.css';

export function AppLayout({ children }) {
  const location = useLocation();
  // Account for language-prefixed routes (e.g. /en/map, /it/map)
  const isMapPage = location.pathname.endsWith('/map');
  const isReportsPage = location.pathname.includes('/reports');
  // Check if we're on a specific report workspace page (e.g. /reports/123)
  const isReportWorkspace = isReportsPage && /\/reports\/[^/]+/.test(location.pathname);
  
  return (
    <div className="app-layout">
      <Sidebar />
      <Header />
      <main
        className={`app-layout__content ${isMapPage ? 'app-layout__content--map' : ''} ${isReportWorkspace ? 'app-layout__content--report' : isReportsPage ? 'app-layout__content--reports' : ''}`}
      >
        {children}
      </main>
    </div>
  );
}